"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(message) {
    const args = ['PING'];
    if (message) {
        args.push(message);
    }
    return args;
}
exports.transformArguments = transformArguments;
